
import axios from 'axios';

const backendURL = `https://videoexpressbackend.onrender.com`;

// function flatten(videoResults){
//     let arr = [];
//     for(let platform of videoResults){
//         for(let video of platform){
//             console.log(video);
//             arr.push(video);
//         }
//     }
//     return arr;
// }

function flatten(videoResults){
    let arr = [];
    const data = videoResults.data;

    for (const key in data) {
        if (data.hasOwnProperty(key)) {
          arr.push(...data[key]);
        }
    }

    return arr;
}

async function search(searchTerm){
    // console.log(searchTerm);

    searchTerm = searchTerm.searchTerm; ///-fix this later

    const searchURL = `${backendURL}/search/${searchTerm}`;
    const results = await axios.get(searchURL);
    const videoArray = flatten(results);
    // console.log(videoArray);
    return videoArray;
}

export default search;